import React from 'react';

function ImageModal({ open, src, alt = 'Imagen', onClose }) {
  React.useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  if (!open) return null;

  const handleBackdrop = (e) => {
    if (e.target.classList.contains('tm-modal-backdrop')) {
      onClose();
    }
  };

  return (
    <div className="tm-modal-backdrop" onClick={handleBackdrop}>
      <div className="tm-modal" role="dialog" aria-modal="true">
        <button className="tm-modal-close" aria-label="Cerrar" onClick={onClose}>×</button>
        <div className="tm-modal-body" style={{ gridTemplateColumns: '1fr' }}>
          <div className="tm-modal-image">
            <img src={src} alt={alt} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImageModal;


